import { useState } from "react"
import { useEffect } from "react"
import { getAppreciationData } from "../service/api"

import { useNavigate, useLocation } from 'react-router-dom'

import '../components/css/Appreciation.css'



const AppreciationBlog = () => {

    const navigate = useNavigate()

    let { state } = useLocation()

    const [data, setData] = useState()

    const [id, setId] = useState()

    let [State, setState] = useState()

    useEffect(() => {
        // let localstate = localStorage.getItem('state')
        // if (localstate) {
        //     setState(localstate)
        //     state = localstate
        // }
        fetchApi()
    }, [state])



    const fetchApi = async () => {

        // //

        try {

            setId({ id: state.id })

            let Id = state.id

            const resp = await getAppreciationData(Id)

            if (resp.data.ResponseData.length) setData(resp.data.ResponseData[0])
        }
        catch (err) {


        }


    }
    const navigateFunc = () => {

        //

        if (state.hasOwnProperty('show')) {

            navigate("/appreciation")
        }
        else {

            navigate("/overview")
        }


    }



    return (
        <>
            <div className="container-fluid cover-pic mt-5">
                <div className="d-flex justify-content-center">
                    <div className="col-md-8 mt-5 bg-white rounded-3">
                        <div className="position-relative">
                            <div className="appreciation-cover-pic rounded-3 position-relative">
                                <a ><img onClick={() => { navigateFunc() }} src="/Images/Annoucement-back-button.svg" className="position-absolute appreciation-backbutton-posi" /></a>
                            </div>
                        </div>
                        <div className="Profile-style position-absolute">
                            <img src="/Images/logo-person-user-person-icon.jpg" className="profile-image mb-2" alt="" />
                            <p className="bold-text font-14 mb-0">{data?.feedto}</p>
                            <p className="semibold-text font-12">{data?.domain}</p>
                        </div>
                        <div className="Appreciation-style mx-4 px-3 position-relative">
                            <p className="regular-text font-14 para-style">{data?.feedback}</p>
                            <div className="float-end">
                                <p className="regular-text font-14 mb-1">By</p>
                                <p className="Textname regular-text font-14">{data?.feedby}</p>
                            </div>
                        </div>
                        <div className="position-absolute Bigquotes-style">
                            <img src="/Images/BigQuotes.svg" className alt="Quotes image" />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}

export default AppreciationBlog